import { Box, Modal, Typography } from "@mui/material";

interface BookItem {
  title: string;
  author?: string;
  image?: string; // 이미지가 없을 수도 있으므로 옵셔널 처리
  isBorrowed?: boolean;
}

interface Props {
  open: boolean;
  onClose: () => void;
  results: BookItem[];
  searchText: string;
  loading?: boolean;
  error?: string | null;
  onRetry?: () => void;
}

const DEFAULT_BOOK_IMAGE = "/images/nobook.png";

export default function SearchBookModal({
  open,
  onClose,
  results,
  searchText,
  loading = false,
  error = null,
  onRetry,
}: Props) {
  return (
    <Modal open={open} onClose={onClose} className="hp-search-sheet__modal">
      <Box
        component="section"
        role="dialog"
        aria-modal="true"
        aria-labelledby="book-search-title"
        aria-busy={loading}
        tabIndex={-1}
        className="hp-search-sheet"
      >
        <div className="hp-search-sheet__header">
          <div>
            <Typography
              component="h2"
              id="book-search-title"
              className="hp-search-sheet__title"
            >
              '{searchText}' 검색 결과
            </Typography>
            <Typography className="hp-search-sheet__count" aria-live="polite">
              {loading ? "검색 중" : `${results.length}건`}
            </Typography>
          </div>
          <button
            type="button"
            className="hp-search-sheet__close"
            onClick={onClose}
            aria-label="검색 결과 닫기"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <Typography component="h3" className="hp-search-sheet__section-title">
          작은 도서관 보유 도서
        </Typography>

        {loading ? (
          <div className="hp-search-sheet__status" role="status">
            <span className="hp-search-sheet__spinner" aria-hidden="true" />
            <Typography>도서를 찾고 있어요.</Typography>
          </div>
        ) : error ? (
          <div className="hp-search-sheet__status hp-search-sheet__status--error" role="alert">
            <Typography>{error}</Typography>
            {onRetry && (
              <button type="button" className="hp-search-sheet__retry" onClick={onRetry}>
                다시 시도
              </button>
            )}
          </div>
        ) : results.length === 0 ? (
          <div className="hp-search-sheet__status">
            <Typography>검색 결과가 없어요.</Typography>
            <Typography className="hp-search-sheet__status-description">
              도서명이나 저자명을 바꿔 다시 검색해 보세요.
            </Typography>
          </div>
        ) : (
          <ul className="hp-book-result-list" aria-label="검색된 도서 목록">
            {results.map((book, index) => (
              <li key={`${book.title}-${book.author}-${index}`} className="hp-book-result">
                <div className="hp-book-result__visual">
                  <img
                    className="hp-book-result__cover"
                    src={book.image || DEFAULT_BOOK_IMAGE}
                    alt={book.title}
                    onError={(event) => {
                      event.currentTarget.onerror = null;
                      event.currentTarget.src = DEFAULT_BOOK_IMAGE;
                    }}
                  />
                  {book.isBorrowed ? <span className="hp-book-borrowed-badge">대여중</span> : null}
                </div>
                <div className="hp-book-result__content">
                  <Typography component="p" className="hp-book-result__title">
                    {book.title}
                  </Typography>
                  <Typography component="p" className="hp-book-result__author">
                    {book.author || "작가 정보 없음"}
                  </Typography>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Box>
    </Modal>
  );
}
